// extracted by mini-css-extract-plugin
module.exports = {"text-gradient":"Report_text-gradient__1JVRJ","text":"Report_text__2w99A","btns":"Report_btns__2kGkq","button":"Report_button__FPK1O"};